import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { message } from 'ant-design-vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('@/layouts/MainLayout.vue'),
      children: [
        {
          path: '',
          redirect: '/timesheet/entry',
        },
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/DashboardView.vue'),
          meta: { requiresApprovalAdmin: true },  // 审批管理员及以上可见
        },

        {
          path: 'timesheet/entry',
          name: 'timesheet-entry',
          component: () => import('@/views/timesheet/EntryView.vue'),
        },
        {
          path: 'timesheet/query',
          name: 'timesheet-query',
          component: () => import('@/views/timesheet/QueryView.vue'),
        },
        {
          path: 'timesheet/monthly-check',
          name: 'timesheet-monthly-check',
          component: () => import('@/views/timesheet/MonthlyCheckView.vue'),
          meta: { requiresApprovalAdmin: true },  // 审批管理员及以上可见
        },
        {
          path: 'export/monthly',
          name: 'export-monthly',
          component: () => import('@/views/export/MonthlyView.vue'),
          meta: { requiresSystemAdmin: true },  // 系统管理员及以上可见
        },
        {
          path: 'import/salary',
          name: 'import-salary',
          component: () => import('@/views/import/SalaryView.vue'),
          meta: { requiresSystemAdmin: true },  // 系统管理员及以上可见
        },
        {
          path: 'audit/logs',
          name: 'audit-logs',
          component: () => import('@/views/audit/LogsView.vue'),
          meta: { requiresApprovalAdmin: true },  // 审批管理员及以上可见
        },
        {
          path: 'audit/project',
          name: 'audit-project',
          component: () => import('@/views/audit/ProjectAuditView.vue'),
          meta: { requiresApprovalAdmin: true },  // 审批管理员及以上可见
        },
        {
          path: 'settings/project-approver',
          name: 'settings-project-approver',
          component: () => import('@/views/settings/ProjectApproverConfig.vue'),
          meta: { requiresSuperAdmin: true },  // 超级管理员可见
        },
        {
          path: 'settings/role-config',
          name: 'settings-role-config',
          component: () => import('@/views/settings/RoleConfigView.vue'),
          meta: { requiresSuperAdmin: true },  // 超级管理员可见
        },
        {
          path: 'settings/profile',
          name: 'settings-profile',
          component: () => import('@/views/settings/ProfileView.vue'),
        },
        {
          path: 'approval/monthly',
          name: 'approval-monthly',
          component: () => import('@/views/approval/MonthlyView.vue'),
          meta: { requiresApprovalAdmin: true },  // 审批管理员及以上可见
        },
        {
          path: 'statistics/department-cost',
          name: 'statistics-department-cost',
          component: () => import('@/views/statistics/DepartmentCostView.vue'),
          meta: { requiresApprovalAdmin: true }  // 审批管理员及以上可见
        },
        {
          path: 'statistics/department-project-matrix',
          name: 'statistics-department-project-matrix',
          component: () => import('@/views/statistics/DepartmentProjectMatrix.vue'),
          meta: { requiresApprovalAdmin: true }  // 审批管理员及以上可见
        },
        {
          path: 'statistics/client-hours',
          name: 'statistics-client-hours',
          component: () => import('@/views/statistics/ClientHoursView.vue'),
          meta: { requiresApprovalAdmin: true }  // 审批管理员及以上可见
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  authStore.initFromStorage()

  // 未登录且非公开页面
  if (!to.meta.public && !authStore.isAuthenticated) {
    next('/login')
    return
  }

  // 层级继承权限检查：
  // 超级管理员 > 系统管理员 > 审批管理员 > 普通用户

  // 需要超级管理员权限的页面
  if (to.meta.requiresSuperAdmin) {
    if (!authStore.isSuperAdmin) {
      message.error('您没有权限访问此页面，仅超级管理员可访问')
      next('/')
      return
    }
  }

  // 需要系统管理员权限的页面（超级管理员 + 系统管理员）
  if (to.meta.requiresSystemAdmin) {
    if (!authStore.isSuperAdmin && !authStore.isSystemAdmin) {
      message.error('您没有权限访问此页面，仅系统管理员及以上可访问')
      next('/')
      return
    }
  }

  // 需要审批管理员权限的页面（超级管理员 + 审批管理员，不含系统管理员）
  if (to.meta.requiresApprovalAdmin) {
    if (!authStore.isSuperAdmin && !authStore.isApprovalAdmin) {
      message.error('您没有权限访问此页面，仅审批管理员或超级管理员可访问')
      next('/')
      return
    }
  }

  next()
})

export default router
